import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ParticipanteConglomerado } from 'src/app/model/participante.conglomerado.model';
import { ConglomeradoService } from '../../conglomerado.service';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Conglomerado } from 'src/app/model/conglomerado.model';
import { MensagemService } from 'src/app/features/mensagem.service';
import { BaseEntityComponent, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';

interface SelectAcao {
  id: number;
  descricao: string;
}

@Component({
    selector: 'app-novo-conglomerado',
    templateUrl: './novo-conglomerado.component.html',
    styleUrls: ['./novo-conglomerado.component.scss'],
    standalone: false
})
export class NovoConglomeradoComponent
  extends BaseEntityComponent<Conglomerado> implements OnInit {

  conglomerado: Conglomerado;
  conglomeradoForm: FormGroup;
  agentesFinanceiros: AgenteFinanceiro[] = [];
  agenteFinanceiroSelecionado: AgenteFinanceiro;
  idConglomerado: number;
  novoConglomerado: boolean;
  edicaoHabilitada: boolean;

  @ViewChild('msgTemplateInativar')
  msgTemplateInativar: TemplateRef<any>;
  @ViewChild('botoesPersonalizadosInativar')
  botoesPersonalizadosInativar: TemplateRef<any>;

  @ViewChild('msgTemplateCancelar')
  msgTemplateCancelar: TemplateRef<any>;
  @ViewChild('botoesPersonalizadosCancelar')
  botoesPersonalizadosCancelar: TemplateRef<any>;
  conglomeradoComPercentualManual: boolean  = false;
  tipoConglomeradoDiferenteDaConfigModalidade: boolean = false;

  constructor(
    protected injector: Injector,
    private conglomeradoService: ConglomeradoService,
    private mensagemService: MensagemService,
    private bnLoadingService: BnLoadingService,
    private bnModalService: BnModalMessageService,
    private modalidadeService: ModalidadeService) {
    super(conglomeradoService);

    this.conglomeradoForm = this.formBuilder.group({
      agenteFinanceiro: [null],
      percentual: [null]
    });
  }

  ngOnInit(): void {
    this.edicaoHabilitada = false;

    this.modalidadeService.modalidadeTipoConglomeradoManual$
      .subscribe((result) => {
        this.conglomeradoComPercentualManual = result;
        this.verificaTipoConglomeradoEAtivaPercentualManual();
      });

    this.route.params.subscribe(params => {
      this.idConglomerado = params['id'];

      this.carregarConglomerado();

      this.conglomeradoService.obterAgentesDisponiveis(this.idConglomerado).subscribe(agentes => this.agentesFinanceiros = agentes);
    });
  }

  verificaTipoConglomeradoEAtivaPercentualManual() {
    if (this.conglomeradoComPercentualManual) {
      this.conglomeradoForm.get('percentual').addValidators(Validators.required);
    } else {
      this.conglomeradoForm.get('percentual').removeValidators(Validators.required);
    }
  }

 async carregarConglomerado() {
    if (this.idConglomerado) {
       await this.conglomeradoService.getConglomerado(this.idConglomerado)
      .toPromise().then(conglomerado => {
        this.conglomerado = conglomerado;
        this.tipoConglomeradoDiferenteDaConfigModalidade = this.conglomeradoComPercentualManual != (!this.conglomerado.percentualAutomatico);
        this.conglomeradoComPercentualManual = !this.conglomerado.percentualAutomatico;
        this.verificaTipoConglomeradoEAtivaPercentualManual();
        this.bnLoadingService.liberaTela();
      });
      this.novoConglomerado = false;

      if (!this.podeEditar()) {
        this.conglomeradoForm.get('acoes')?.disable();
      }
    } else {
      this.novoConglomerado = true;
      this.carregarNovoConglomerado();
      this.edicaoHabilitada = true;
    }
  }

  getPercentualMostrar() {
    if (this.conglomerado && this.conglomerado.participanteConglomerado) {
      let totalPercentual = this.conglomerado.participanteConglomerado.filter((p) => p.dataFinal == null)
          .map((p) => Number(p.percentual))
          .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
      return Math.round(totalPercentual * 10000) / 10000;
    }
    return null;
  }

  async salvar() {
    try {
      let totalPercentual = this.conglomerado.participanteConglomerado.map((p) => Number(p.percentual))
        .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
      totalPercentual =  Math.round(totalPercentual * 10000);
      if (totalPercentual != 10000) {
        this.mensagemService.adicionarMensagemErro(`O valor total dos percentuais lançados deve ser igual a 100%. O percentual de participação total do conglomerado é de 100%, divido entre os participantes.`);
        return;
      }
      if (this.idConglomerado) {
        await this.conglomeradoService.editar(this.idConglomerado, this.conglomerado.participanteConglomerado).toPromise();
      } else {
        await this.conglomeradoService.salvar(this.conglomerado).toPromise();
      }

      this.mensagemService.adicionarMensagemSucesso('Conglomerado criado/atualizado com sucesso.');

      if (this.novoConglomerado) {
        this.irParaPesquisa();
      } else {
        this.resetarTela();
      }
    } catch (err) {
      console.log('Erro ao salvar conglomerado', err);
      this.mensagemService.adicionarMensagemErro('Erro ao salvar conglomerado');
    }
  }

  habilitarEdicao() {
    let participantes = this.conglomerado.participanteConglomerado.filter(participante => participante.dataFinal == null);
    this.conglomerado.participanteConglomerado = [];

    participantes.forEach(participante => this.adicionarParticipante(participante.agenteFinanceiro, participante.percentual));
    this.atualizarValores();

    this.edicaoHabilitada = true;
  }

  async inativar() {
    try {
      await this.conglomeradoService.editar(this.idConglomerado, []).toPromise();

      this.mensagemService.adicionarMensagemSucesso('Conglomerado inativado com sucesso.');

      this.resetarTela();
      this.dismissModal();
    } catch (err) {
      console.log('Erro ao inativar conglomerado', err);
      this.mensagemService.adicionarMensagemErro('Erro ao salvar conglomerado');
    }
  }

  carregarNovoConglomerado() {
    this.conglomeradoService.getNovoConglomerado().subscribe(novoConglomerado => this.conglomerado = novoConglomerado);
  }

  cancelar() {
    this.dismissModal();

    if (this.novoConglomerado) {
      this.irParaPesquisa();
    } else {
      this.resetarTela();
    }
  }

  incluirNoConglomerado() {
    if (this.conglomeradoForm.invalid) {
      this.conglomeradoForm.markAllAsTouched();
      return;
    }
    let percentual = null;
    if (this.conglomeradoComPercentualManual) {
      percentual = Number(this.conglomeradoForm.get('percentual').value) / 100;
    }
    this.adicionarParticipante(this.agenteFinanceiroSelecionado, percentual);
    this.atualizarValores();
    this.conglomeradoForm.get('agenteFinanceiro').setValue('');
    this.conglomeradoForm.get('percentual').setValue('');
    this.agenteFinanceiroSelecionado = null;
  }

  adicionarParticipante(agenteFinanceiroInclusao: AgenteFinanceiro, percentual?: number) {
    let participanteConglomerado: ParticipanteConglomerado = new ParticipanteConglomerado();
    participanteConglomerado.agenteFinanceiro = agenteFinanceiroInclusao;
    if (percentual != null) {
      participanteConglomerado.percentual = percentual;
    }
    participanteConglomerado.idConglomerado = this.idConglomerado;
    participanteConglomerado.dataInicial = new Date();
    if (!this.conglomerado.participanteConglomerado.some(participante => participante.dataFinal == null && participante.agenteFinanceiro.id === agenteFinanceiroInclusao.id)) {
      this.conglomerado.participanteConglomerado.push(participanteConglomerado);
    }
  }

  atualizarValores() {
    if (!this.conglomeradoComPercentualManual) {
      this.conglomeradoService
        .atualizaValoresParticipantes(this.conglomerado.participanteConglomerado)
        .subscribe(participantes => this.conglomerado.participanteConglomerado = participantes);
    }
  }

  irParaPesquisa() {
    this.router.navigate(['habilitacao', 'conglomerado']);
  }

  resetarTela() {
    this.carregarConglomerado();
    this.edicaoHabilitada = false;
    this.conglomeradoForm.reset();
  }

  selecionar(agente: AgenteFinanceiro) {
    this.agenteFinanceiroSelecionado = agente;
  }

  podeSalvar() {
    return this.conglomerado?.participanteConglomerado.filter(participante => participante.dataFinal == null).length >= 2 && (this.novoConglomerado || this.edicaoHabilitada);
  }

  remover(index: number) {
    this.conglomerado.participanteConglomerado.splice(index, 1);
    this.atualizarValores();
  }

  desabilitaOpcao(agente: AgenteFinanceiro) {
    return agente.possuiConglomerado || this.conglomerado?.participanteConglomerado.some(participante => participante.dataFinal == null && participante.agenteFinanceiro.id === agente.id);
  }

  tratarInativacao(data) {
    console.log(data);
    this.conglomerado.participanteConglomerado.filter(agente => agente.id != null && agente.dataFinal == null).forEach(agente => agente.dataFinal = data);
  }

  podeEditar() {
    return this.conglomerado?.participanteConglomerado.some(participante => participante.dataFinal == null);
  }

  abrirConfirmacao() {
    this.bnModalService.abrir(
      'Confirmação',
      'Esta ação irá inativar todo o Conglomerado. Você confirma?',
      'lg',
      this.msgTemplateInativar,
      this.botoesPersonalizadosInativar
    );
  }

  abrirConfirmacaCancelar() {
    this.bnModalService.abrir(
      'Confirmação',
      'Descartar edição do Conglomerado?',
      'lg',
      this.msgTemplateCancelar,
      this.botoesPersonalizadosCancelar
    );
  }

  dismissModal() {
    this.bnModalService.dismiss();
  }
}
